import script from "./ModelIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./ModelIndex.vue?vue&type=script&setup=true&lang=js"

import "./ModelIndex.vue?vue&type=style&index=0&id=1d584a7c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d584a7c"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QInnerLoading});
